import { Injectable } from '@angular/core';
import { ServerService } from '../server/server.service';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private server: ServerService, private router: Router) { }

  tokenKey: string = 'access_token';

  hasToken(): boolean {
    const token = localStorage.getItem(this.tokenKey);
    return !!token && token.trim() !== '';
  }

  async isAuthorized(): Promise<boolean> {
    if (!this.hasToken()) {
      return false;
    }

    try {
      return (await lastValueFrom(this.server.onVerifyUserToken())).success;
    } catch {
      return false;
    }
  }

  async isLoggedIn(): Promise<boolean> {
    const ok = await this.isAuthorized();
    if (!ok) {
      this.logout();
    }
    return ok;
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    this.router.navigate(['login']);
  }

}
